import PaymentSettingsForm from '../organisms/forms/PaymentSettingsForm';
import { PAYMENT_TYPE } from '../../constants/enums';
import { usePaymentSettings } from '../../hooks/usePaymentSettings';

const WithdrawalSettingsPage = () => {
  const {
    currency,
    control,
    handleSubmit,
    formState: { errors, isDirty },
    onFormSubmit,
    hideInputs,
    disableInputs,
    approvalModeOptions,
  } = usePaymentSettings(PAYMENT_TYPE.WITHDRAWAL);

  return (
    <PaymentSettingsForm
      currency={currency}
      isDirty={isDirty}
      control={control}
      errors={errors}
      onSave={handleSubmit(onFormSubmit)}
      hideInputs={hideInputs}
      disableInputs={disableInputs}
      approvalModeOptions={approvalModeOptions}
    />
  );
};

export default WithdrawalSettingsPage;
